import { useEffect } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { Login } from "./routes/login";
import { Shell } from "./components/layout/shell";
import { Dashboard } from "./routes/dashboard";
import { CallsList } from "./routes/calls/list";
import { CallDetail } from "./routes/calls/detail";
import { CallsLive } from "./routes/calls/live";
import { BookingsList } from "./routes/bookings/list";
import { TenantsList } from "./routes/tenants/list";
import { TenantSettings } from "./routes/tenants/settings";
import { CallbacksList } from "./routes/callbacks/list";
import { KbList } from "./routes/kb/list";
import { ForwardsList } from "./routes/forwards/list";
import { NumbersList } from "./routes/numbers/list";
import { VoiceSimulator } from "./routes/dev/voice-simulator";
import { CrmPipeline } from "./routes/crm/pipeline";
import { CrmAgenda } from "./routes/crm/agenda";
import { CrmRevenues } from "./routes/crm/revenues";
import { CrmAccount } from "./routes/crm/account";
import { useAuthStore } from "./stores/auth";

export default function App() {
  const { user, loading, refresh } = useAuthStore();

  useEffect(() => {
    refresh();
  }, [refresh]);

  if (loading) {
    return <div className="boot">Chargement…</div>;
  }

  if (!user) return <Login />;

  return (
    <Shell>
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard" />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/calls" element={<CallsList />} />
        <Route path="/calls/live" element={<CallsLive />} />
        <Route path="/calls/:callId" element={<CallDetail />} />
        <Route path="/bookings" element={<BookingsList />} />
        <Route path="/callbacks" element={<CallbacksList />} />
        <Route path="/kb" element={<KbList />} />
        <Route path="/forwards" element={<ForwardsList />} />
        <Route path="/tenants" element={<TenantsList />} />
        <Route path="/numbers" element={<NumbersList />} />
        <Route path="/tenants/:tenantId/settings" element={<TenantSettings />} />
        <Route path="/dev/voice-simulator" element={<VoiceSimulator />} />
        <Route path="/crm" element={<CrmPipeline />} />
        <Route path="/crm/agenda" element={<CrmAgenda />} />
        <Route path="/crm/revenus" element={<CrmRevenues />} />
        <Route path="/crm/dossiers/:accountId" element={<CrmAccount />} />
      </Routes>
    </Shell>
  );
}
